var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn",class:[_vm.style, _vm.small, _vm.addClass],attrs:{"role":"button","title":_vm.title,"aria-label":_vm.title},on:{"click":_vm.click}},[(_vm.icon != null)?_c('q-icon',{staticClass:"mr--1",attrs:{"icon":_vm.icon}}):_vm._e(),_vm._v("\n  "+_vm._s(_vm.title)+"\n")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }